import Tile from './Tile'

export default Tile



// WEBPACK FOOTER //
// ./src/views/Home/components/Tile/index.js